module.exports = __webpack_public_path__ + "img/image-uploader.34acdaa7.png";